import React from 'react';
import PropTypes from 'prop-types';

import { LOGIN_STATE } from '@xingternal/xing-frame-provider/constants';

import View from './XingView';

const LoggedoutView = ({ children, ...props }) => (
  <View loginState={LOGIN_STATE.loggedOut} {...props}>
    {children}
  </View>
);
LoggedoutView.propTypes = {
  children: PropTypes.node,
};

export default LoggedoutView;
